import { paymentTypeSchema, promotionTypeSchema } from '@server/presentation'
import { z } from 'zod'

export const getSubscribeTicketsReqSchema = z.object({
  paymentType: paymentTypeSchema.exclude(['EXTEND']),
  langType: z.enum(['EN', 'JP', 'ENJP']).optional(),
  lessonCountPerMonth: z.enum(['8', '12', '999']).optional(),
  lessonTime: z.enum(['15', '25']),
  curriculumType: z.enum(['BASIC', 'BUSINESS', 'SMART_TALK']).optional().default('BASIC'),
  promotionType: promotionTypeSchema.optional(),
})

export type GetSubscribeTicketsReqSchema = z.infer<typeof getSubscribeTicketsReqSchema>
